module.exports = __webpack_public_path__ + "static/media/20151105_122411_850.d2688488.jpg";